import ReportEditableRepository from "@/repositories/vns/ReportEditableRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'reportEditable',
    namespaced: true,
    state: {
        ...makeState(),
        reportEditablesByVns: []
    },    
    getters: {
        ...makeGetters(),
        allByVns (state) {
            return state.reportEditablesByVns
        }
    },
    mutations: {
        ...makeMutations(),
        setAllByVns (state, array) {
            state.reportEditablesByVns = array
        },
    },
    actions: {
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await ReportEditableRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.vnsReportEditables)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async listByVns ({ commit }, id) {
            commit('setLoading', true)
            await ReportEditableRepository.fetchByVns(id).then(response => {
                commit('setAllByVns', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
